import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Redirect } from "react-router-dom";
import {
  Loading,
  Set_Current_User,
  Set_Permission,
  Set_Role,
} from "redux/Action";
import AddEmployee from "views/AddEmployee";
import AddShipment from "views/AddShipment";
import ListRequest from "views/ListRequest";
import ManageDriver from "views/ManageDriver";
import ListShipment from "views/ListShipment/ListShipment";
import Trucks from "views/Trucks";
import TypeShipment from "views/TypeShipment";
import { axios } from "./axios";

import { RouteWithLayout } from "./components";
import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";

import {
  Dashboard as DashboardView,
  AddProduct as AddProductView,
  SignIn as SignInView,
  NotFound as NotFoundView,
} from "./views";
import AddCompany from "./views/AddCompany";
import SendNotification from "views/SendNotification";
import ManageCity from "views/ManageCity";
import ListPayment from "views/ListPayment";
import Auth from "views/Auth";
import ListAuthRequests from "views/ListAuthRequests";

const Routes = () => {
  const current_Token = useSelector((state) => state.token);
  const current_role = useSelector((state) => state.role);
  const current_user = useSelector((state) => state.userCurrent);
  let Pr_inventory = useSelector((state) => state.permission);

  // console.clear();
  // console.log(Pr_inventory, 'pppppppppp');
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${current_Token}`,
  };
  const dispatch = useDispatch();

  const GetData = async () => {
    try {
      const res = await axios.get("auth/getCurrentUser", {
        headers: headers,
      });

      dispatch(Set_Current_User(res.data));
      localStorage.setItem("CurrentUser", JSON.stringify(res.data));

      dispatch(Set_Role(res.data.roles[0].name));
      localStorage.setItem("role", res.data.roles[0].name);

      let roless = res.data.roles;
      let arr = [];
      let er = [];
      roless.forEach((element) => {
        er = [];
        er = element.permissions;

        er.forEach((e) => {
          arr.push(e.name);
        });
      });
      const uniqueSet = new Set(arr);
      const backToArray = [...uniqueSet];

      dispatch(Set_Permission(backToArray));
      localStorage.setItem("Permission", JSON.stringify(backToArray));
    } catch (e) {
      // console.log(e.response, 'eeeeeeeee');
    }
  };

  useEffect(() => {
    if (current_Token != null) {
      GetData();
    }
  }, [current_Token]);

  useEffect(async () => {
    const resRole = await axios.get("roles/can-create-shipment", {
      headers: headers,
    });
  }, []);

  return (
    <Switch>
      <Redirect exact from="/" to={"/list-request"} />
      {/* {current_user?.is_verified === 0 && ( */}
      <RouteWithLayout
        component={Auth}
        exact
        // layout={MinimalLayout}
        layout={MainLayout}
        showToolbar={false}
        path="/auth"
      />
      <RouteWithLayout
        component={ListAuthRequests}
        exact
        layout={MainLayout}
        path="/auth-requests"
      />
      {/* )} */}

      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("dashboard.viewAny") !== -1 ? (
        <RouteWithLayout
          component={DashboardView}
          exact
          layout={MainLayout}
          path="/dashboard"
        />
      ) : (
        ""
      )}

      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("staff.add") !== -1 ||
      Pr_inventory?.indexOf("staff.viewAny") !== -1 ||
      Pr_inventory?.indexOf("staff.view") !== -1 ? (
        <RouteWithLayout
          component={AddEmployee}
          exact
          layout={MainLayout}
          path="/users"
        />
      ) : (
        ""
      )}
      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("shipment.view") !== -1 ? (
        <RouteWithLayout
          component={ListShipment}
          exact
          layout={MainLayout}
          path="/list-shipment"
        />
      ) : (
        ""
      )}
      {current_role == "Super-Admin" ? (
        <RouteWithLayout
          component={ListPayment}
          exact
          layout={MainLayout}
          path="/list-payment"
        />
      ) : (
        ""
      )}

      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("shipmentRequest.view") !== -1 ? (
        <RouteWithLayout
          component={ListRequest}
          exact
          layout={MainLayout}
          path="/list-request"
        />
      ) : (
        ""
      )}

      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        showToolbar={true}
        path="/not-found"
      />

      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("company.add") !== -1 ||
      Pr_inventory?.indexOf("company.view") !== -1 ||
      Pr_inventory?.indexOf("company.viewAny") !== -1 ? (
        <RouteWithLayout
          component={AddCompany}
          exact
          layout={MainLayout}
          path="/company"
        />
      ) : (
        ""
      )}

      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("manage-drivers.create") !== -1 ||
      Pr_inventory?.indexOf("manage-drivers.view") !== -1 ? (
        <RouteWithLayout
          component={ManageDriver}
          exact
          layout={MainLayout}
          path="/manage-drivers"
        />
      ) : (
        ""
      )}
      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("manage-notifications.send") !== -1 ? (
        <RouteWithLayout
          component={SendNotification}
          exact
          layout={MainLayout}
          path="/send-notification"
        />
      ) : (
        ""
      )}

      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("manage-cities.create") !== -1 ||
      Pr_inventory?.indexOf("manage-cities.edit") !== -1 ? (
        <RouteWithLayout
          component={ManageCity}
          exact
          layout={MainLayout}
          path="/manage-city"
        />
      ) : (
        ""
      )}
      {current_role == "Super-Admin" ||
      Pr_inventory?.indexOf("shipment.add") !== -1 ? (
        <RouteWithLayout
          component={AddShipment}
          exact
          layout={MainLayout}
          path="/add-shipment"
        />
      ) : (
        ""
      )}

      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        showToolbar={false}
        path="/sign-in"
      />

      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
